import "./Footer.css";
const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="footer-bottom-inner">
          <div className="copyright">© Österreichische Nationalbibliothek { new Date().getFullYear() }</div>
          <nav className="meta">
            <ul>
              <li>
                <span>Kontakt: digital@onb.ac.at</span>
              </li>
              <li>
                <a href="https://www.onb.ac.at/impressum" title="Impressum">
                  Impressum
                </a>
              </li>
              <li>
                <a href="https://www.onb.ac.at/datenschutz" title="Datenschutz">
                  Datenschutz
                </a>
              </li>
              <li>
                <a
                  href="https://www.onb.ac.at/barrierefreiheitserklaerung"
                  title="Barrierefreiheitserklärung"
                >
                  Barrierefreiheitserklärung
                </a>
              </li>
              <li>
                <a href="https://www.onb.ac.at/nutzung" title="Nutzung">
                  Nutzung
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
